import actions from "./actions";
import DevicesStateRecord from "@infinode/records/reducers/DevicesStateRecord";
import immutableUtils from "@iso/utils/immutableUtils";
import { Map } from "immutable";
import { createDeviceRecord } from "@infinode/records/DeviceRecord";
import reducerUtils from "../reducerUtils";
import { createDeviceConfigRecord, updateDeviceConfigRecord } from "@infinode/records/DeviceConfigRecord";

export default function devicesReducer(state = DevicesStateRecord(), action) {
  switch (action.type) {
    case actions.GET_DEVICES_REQUEST:
      return state.merge({ devices: Map(), loading: true, error: null });
    case actions.GET_DEVICES_SUCCESS:
      return state.merge({
        devices: action.devices ? immutableUtils.listToMap(action.devices.map(s => createDeviceRecord(s))) : Map(),
        loading: false
      });
    case actions.GET_DEVICE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.GET_DEVICE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("devices", devices => devices.set(action.device.id, createDeviceRecord(action.device)));
      });
    case actions.GET_DEVICE_CONFIG_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.GET_DEVICE_CONFIG_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("devices", devices =>
          devices.setIn([action.id, "deviceConfig"], createDeviceConfigRecord(action.deviceConfig))
        );
      });
    case actions.DELETE_DEVICE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.DELETE_DEVICE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("devices", devices => devices.delete(action.id));
      });
    case actions.UPDATE_DEVICE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.UPDATE_DEVICE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("devices", devices => devices.set(action.device.id, createDeviceRecord(action.device)));
      });
    case actions.UPDATE_DEVICE_CONFIG_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.UPDATE_DEVICE_CONFIG_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("devices", devices =>
          devices.updateIn([action.id, "deviceConfig"], updateDeviceConfigRecord(action.deviceConfig))
        );
      });
    case actions.CREATE_DEVICE_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.CREATE_DEVICE_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.update("devices", devices => devices.set(action.device.id, createDeviceRecord(action.device)));
      });
    case actions.REQUEST_PAIRING_REQUEST:
      return reducerUtils.getRequestState(state).set("pairingSerialNumber", null);
    case actions.REQUEST_PAIRING_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.set("pairingSerialNumber", action.serialNumber);
      });
    case actions.SUBMIT_PAIRING_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.SUBMIT_PAIRING_SUCCESS:
      return state.withMutations(s => {
        s.merge({ loading: false, error: null });
        s.set("pairingSerialNumber", null);
        s.update("devices", devices =>
          devices.set(
            action.pairingResult.device.id,
            createDeviceRecord(
              action.pairingResult.device,
              action.pairingResult.pairingSucceeded,
              action.pairingResult.pairingCodeExpiresSeconds
            )
          )
        );
      });
    case actions.DEVICES_ERROR:
      return state.merge({ loading: false, error: action.error });
    default:
      return state;
  }
}
